const module = { name: 'Fandango/favoriteFlyout', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



const Styles = {
    IS_VISIBLE: 'favoriteFlyout--visible',
    IS_HIDDEN: 'favoriteFlyout--hidden',
}


const Selectors = {
    FLYOUT: '.js-hearts-flyout',
    FLYOUT_MSG: '.js-hearts-flyout-message',
    FLYOUT_ANCHOR: '.js-hearts-flyout-anchor',
    FLYOUT_INNER: '.js-hearts-flyout-anchor__inner',
    ARIA_LIVE: '#js-hearts-aria-live'
}


const Actions = {
    MOVIE_SAVED: 'movie-saved',
    MOVIE_DELETED: 'movie-deleted',
    THEATER_SAVED: 'theater-saved',
    THEATER_DELETED: 'theater-deleted',
    REMOVED: 'removed from',
    ADDED: 'added to'
}


const Msg = {
    MOVIE: 'My Movies',
    THEATER: 'My Theaters',
    ERROR: 'Sorry, something went wrong on our end.  Please try again later.'
}
function initTimer($el) {
    setTimeout(() => $el.removeClass(Styles.IS_VISIBLE), 2000);
}
function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight);
}
function findPosition($el) {
    const $anchorInner = $(Selectors.FLYOUT_INNER);
    const innerLeft = $anchorInner.offset().left + $anchorInner.width() - 59;
    const $window = $(window);
    const windowWidth = $window.width();
    const offsetLeft = windowWidth >= 1230 ? 55 : (windowWidth - innerLeft);
    const $anchor = $(Selectors.FLYOUT_ANCHOR);
    const width = $anchor.width();
    const height = $anchor.height();
    const offsetTop = 20;
    return {
        top: $anchor.offset().top - $window.scrollTop() + height + offsetTop,
        left: $anchor.offset().left + width - $el.width() - offsetLeft,
    };
}
function renderFlyout(el) {
    const $el = $(el);
    const $flyout = $el.closest(Selectors.FLYOUT);
    const isVisible = isElementInViewport(document.querySelector(Selectors.FLYOUT_ANCHOR));
    const { top, left } = findPosition($el);
    if (isVisible) {
        $flyout.css('top', top).css('left', left).addClass(Styles.IS_VISIBLE);
        return initTimer($flyout);
    }
    $flyout.css('top', '15px').css('left', left).addClass(Styles.IS_VISIBLE);
    initTimer($flyout);
}
function getFlyoutText(el, action, type) {
    const isMovie = (type === Actions.MOVIE_DELETED || type === Actions.MOVIE_SAVED);
    if (action === 'error') {
        return Msg.ERROR;
    }
    return `${el.dataset.name} ${action} ${isMovie ? Msg.MOVIE : Msg.THEATER}`;
}
function showFlyout(el, action, type) {
    const msgEl = document.querySelector(Selectors.FLYOUT_MSG);
    if (!msgEl) {
        return;
    }
    const parentEl = msgEl.closest(Selectors.FLYOUT);
    const text = getFlyoutText(el, action, type);
    const itemRemoved = action === Actions.REMOVED;
    parentEl.classList.remove(Styles.IS_HIDDEN);
    if (itemRemoved) {
        parentEl.classList.add(Styles.IS_HIDDEN);
    }
    msgEl.innerHTML = text;
    renderFlyout(msgEl);
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
module.exports = {
    showFlyout,
};
extendLegacy('favoriteFlyout', module.exports);
export default module.exports;